<template>
  <canvas ref="riveCanvas" :width="canvasWidth" :height="canvasHeight" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRiveLoader } from '@/composables/useRiveLoader';
import { useInstance } from '@/composables/useInstance';

// Dedicated component so useRiveLoader's onMounted/onBeforeUnmount lifecycle
// runs on every show/hide of the loader overlay (it sits under a v-if).
const { $vuetify } = useInstance();
const size = computed(() => ($vuetify.breakpoint.smAndDown ? 120 : 164));

const { riveCanvas, canvasWidth, canvasHeight } = useRiveLoader({
  width: size,
  height: size,
});
</script>
